import is from 'is_js';
import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';
import * as accessors from './accessors';

export const FETCH_STUDENT_REQUEST = 'FETCH_STUDENT_REQUEST';
export const FETCH_STUDENT_SUCCESS = 'FETCH_STUDENT_SUCCESS';
export const FETCH_STUDENT_FAILURE = 'FETCH_STUDENT_FAILURE';

const buildStudentUrl = (studentId) => buildUrl(`/students/${studentId}`);

export function getApiCallState(state, studentId) {
  return ApiCall.find(state, { method: 'GET', url: buildStudentUrl(studentId) });
}

export function fetchStudentIfNeeded(studentId) {
  return (dispatch, getState) => {
    const state = getState();
    if (is.existy(accessors.getStudentById(state, studentId)) ||
        ! ApiCall.shouldPerform(state, { method: 'GET', url: buildStudentUrl(studentId) })) {
      return false;
    }

    return dispatch(fetchStudent(studentId));
  };
}

export function fetchStudent(studentId) {
  return (dispatch) => {
    const url = buildStudentUrl(studentId);
    const method = 'GET';

    return dispatch(fetchStudentRequest()).payload
      .then((response) => dispatch(fetchStudentSuccess(response)))
      .catch((error) => dispatch(fetchStudentFailure(error)));

    function fetchStudentRequest() {
      return ApiCall.createAction({
        type: FETCH_STUDENT_REQUEST,
        payload: fetch(url),
        url,
        method,
        studentId,
        disableDefault: true,
      });
    }

    function fetchStudentSuccess(student) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_SUCCESS,
        payload: student,
        url,
        method,
        studentId,
      });
    }

    function fetchStudentFailure(error) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_FAILURE,
        error,
        url,
        method,
        studentId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./containers/Student/actions.js